module.exports = __webpack_public_path__ + "img/map_Z2.7.B.02.8992e17e.svg";